import { CreateFinancialAccountInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationFinancialAccountCreateAtom = createMutationAtomFactory(
  'finance.financialAccountCreate',
  (params: CreateFinancialAccountInput) => ({
    financeFinancialAccountCreate: {
      __args: {
        input: params,
      },
      __scalar: true,
      name: true,
      type: true,
      currentBalance: {
        __scalar: true,
      },
      currency: true,
      visibleInPayments: true,
      roundingMethod: true,
      roundingPrecision: true,
      nachaCompanyIdentification: true,
      nachaCompanyName: true,
      nachaDefaultSecCode: true,
      timestamps: {
        __scalar: true,
      },
    },
  }),
);
